import React, { useState, useEffect } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Col
} from 'reactstrap';
import classnames from 'classnames';
import DivisionLetters from './DivisionLetters';
import AccountLetters from './AccountLetters';
import LetterTemplates from './LetterTemplates';
import { getAccount } from '../../API';
import QueryString from 'query-string';

function Letters(props) {
    const [activeTab, setActiveTab] = useState('division');
    const [selectedAccounts, setSelectedAccounts] = useState([]);

    useEffect(() => {
        checkQueryString();
    }, []);

    const checkQueryString = async () => {
        if (props.location.search) {
            const qs = QueryString.parse(props.location.search);
            if (qs.accountId) {
                setSelectedAccounts([await getAccount(qs.accountId)]);
                setActiveTab('account');
            }
        }
    };

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <div id="letters">
            <Row className="header-row">
                <Col>
                    <h1>Letters</h1>
                </Col>
            </Row>
            <Row className="tabs-row">
                <Col>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'division' })}
                                onClick={() => { toggle('division'); }}>
                                By Program
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'account' })}
                                onClick={() => { toggle('account'); }}>
                                By Account
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
            </Row>
            <Row className="tab-content-row">
                <Col>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="division">
                            <DivisionLetters/>
                        </TabPane>
                        <TabPane tabId="account">
                            <AccountLetters selectedAccounts={selectedAccounts}/>
                        </TabPane>
                    </TabContent>
                </Col>
            </Row>
        </div>
    );
}

export default Letters;